export const COMMISSION = 0.10;

export const CATEGORIES = [
  'Pain Relief',
  'Antibiotics',
  'Malaria',
  'Diabetes',
  'Vitamins',
  'General',
  'Skincare',
  'Baby & Mother',
  'Supplements',
  'Cardiovascular',
  'Respiratory',
  'Digestive',
  'Eye & Ear',
  'Mental Health',
  'Hormones',
  'Other',
];

export const STATUS_OPTIONS = [
  'pending',
  'preparing',
  'dispatched',
  'delivering',
  'delivered',
  'cancelled',
];

export const STATUS_COLORS = {
  pending: '#F59E0B',
  preparing: '#3B82F6',
  dispatched: '#8B5CF6',
  delivering: '#F97316',
  delivered: '#10B981',
  cancelled: '#EF4444',
};

export const STATUS_ICONS = {
  pending: '⏳',
  preparing: '💊',
  dispatched: '🛵',
  delivering: '📍',
  delivered: '✅',
  cancelled: '✕',
};